// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_wrapper__YRjGR {
  display: flex;
  align-items: center;
  align-self: flex-end;
  column-gap: 16px;
}
@media (max-width: 992px) {
  .styles_wrapper__YRjGR {
    flex-wrap: wrap;
  }
}
@media (max-width: 768px) {
  .styles_wrapper__YRjGR {
    align-self: unset;
  }
}
@media (max-width: 576px) {
  .styles_wrapper__YRjGR {
    justify-content: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/pageFooter/navBlock/styles.module.scss","webpack://./src/assets/styles/mixin/breakpoints.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;AADF;ACoBE;EDvBF;IAOI,eAAA;EAAF;AACF;ACqBE;ED7BF;IAWI,iBAAA;EACF;AACF;ACsBE;EDnCF;IAeI,uBAAA;EAEF;AACF","sourcesContent":["@import '../../../assets/styles/mixin/breakpoints';\n\n.wrapper {\n  display: flex;\n  align-items: center;\n  align-self: flex-end;\n  column-gap: 16px;\n\n  @include lg {\n    flex-wrap: wrap;\n  }\n\n  @include md {\n    align-self: unset;\n  }\n\n  @include sm {\n    justify-content: center;\n  }\n}\n","@mixin xxxxl {\n  @media (max-width: 1920px) {\n    @content;\n  }\n}\n\n@mixin xxxl {\n  @media (max-width: 1700px) {\n    @content;\n  }\n}\n\n@mixin xxl {\n  @media (max-width: 1400px) {\n    @content;\n  }\n}\n\n@mixin xl {\n  @media (max-width: 1200px) {\n    @content;\n  }\n}\n\n@mixin lg {\n  @media (max-width: 992px) {\n    @content;\n  }\n}\n\n@mixin md {\n  @media (max-width: 768px) {\n    @content;\n  }\n}\n\n@mixin sm {\n  @media (max-width: 576px) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `styles_wrapper__YRjGR`
};
export default ___CSS_LOADER_EXPORT___;
